import React from "react";
import { Box, Paper } from "@mui/material";
import { AnalysisScoreChart } from "../ScoreChart";
import type { OverallValues } from "../../../types";
import RelativePerformanceScore from "./RelativePerformanceScore";

export default function OverallBlock({ overall }: { overall: OverallValues }) {
  return (
    <Paper
      sx={{
        pt: 1,
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
        bgcolor: "#1c1c1c",
        backgroundImage: "none",
      }}
    >
      <Box>
        <AnalysisScoreChart value={overall.self} label={"Self"} />
      </Box>
      <Box>
        <AnalysisScoreChart value={overall.given} label={"Given"} />
      </Box>
      <Box>
        <AnalysisScoreChart value={overall.received} label={"Received"} />
      </Box>
      <RelativePerformanceScore rps={overall.rps} />
    </Paper>
  );
}
